import axios from 'axios'

const endpoints = {
  CCP_SEND: '/v2/ccp/send',
  CCP_GET_IMAGE_UPLOAD_URL: '/v2/ccp/user/uploadImage',
  MESSAGE_CONVERSATION: '/v2/message/conversation',
  CCP_GET_PICTURES: '/v2/ccp/userData/getUserPictures',
  WEBSOCKET_TYPING: '/v2/websocket/typing',
  MARK_CONVERSATION_READ: '/v2/message/markAsRead',
  CCP_ADD_LOG: '/v2/log/addLog',
  CCP_MONITORING: '/v2/log/monitoring',
}

export class Ccp {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async sendMessage(data, opts) {
    return this.requester.post(endpoints.CCP_SEND, data, opts)
  }

  async getImageUploadUrl(data, opts) {
    return this.requester.post(endpoints.CCP_GET_IMAGE_UPLOAD_URL, data, opts)
  }

  async uploadImage(data, opts) {
    const { file, conversationUid, skipSendAsMessage, mimeType } = data
    const [imageUpload, imageUploadError] = await this.requester.post(endpoints.CCP_GET_IMAGE_UPLOAD_URL, { conversationUid, skipSendAsMessage, mimeType }, opts)
    if(imageUploadError) {
      return [null, imageUploadError]
    }

    const { url, fields } = imageUpload

    const formData = new FormData()
    Object.keys(fields).forEach(key => formData.append(key, fields[key]))
    formData.append('Content-Type', file.type)
    formData.append('file', file)
    return axios.post(url, formData)
      .then(response => {
        if(response.status === 204) {
          return [{ statusCode: 204, code: 'imageUploaded', imageUpload: imageUpload }]
        }
      })
      .catch(error => {
        const { status, statusText, data } = error.response
        return [null, { statusCode: status, code: statusText || data }]
      })
  }

  async fetchMessages(params, opts) {
    return this.requester.get(endpoints.MESSAGE_CONVERSATION, params, opts)
  }

  async getPictures(params, opts) {
    return this.requester.get(endpoints.CCP_GET_PICTURES, params, opts)
  }

  async typing(params, opts = {}) {
    return this.requester.post(endpoints.WEBSOCKET_TYPING, params, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async readConversation({ conversationUid, senderUid }, opts = {}) {
    return this.requester.post(endpoints.MARK_CONVERSATION_READ, { conversationUid, senderUid }, opts)
  }

  async addLog(data, opts) {
    return this.requester.post(endpoints.CCP_ADD_LOG, data, opts)
  }

  async monitoring(data, opts) {
    return this.requester.post(endpoints.CCP_MONITORING, data, opts)
  }
}
